const routeAliasConstant = {
  PROVIDER: '/provider',
  CONSUMER: '/consumer',
  EMPLOYER: '/employer',
  VCARE: '/vcare',
  ADVISOR: '/advisor'
}

export default routeAliasConstant;